import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
type CardFooterProps = {
  readonly className?: string;
  readonly children: ReactNode;
};
export function CardFooter(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex-none", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <footer className={t1}>{children}</footer>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}